export default "__VITE_ASSET__DKLR6G_T__"